import React from "react";

import { Link } from "gatsby";
import { InitialColorProvider } from "@components/layout/SectionColor";

import styles from "./404.module.scss";

export default function PageNotFound() {
  return (
    <div
      className={styles.base}
      data-page-background-color="var(--color-black)"
      data-page-accent-color="var(--color-red)"
      data-page-is-dark
    >
      <InitialColorProvider
        backgroundColor="var(--color-black)"
        accentColor="var(--color-red)"
        isDark={true}
      />
      <Link to="/" data-cursor-cta="Go home">
        <h1 className="xl">Oh no!</h1>
        <p className="large">We couldn’t find that page.</p>
      </Link>
    </div>
  );
}
